import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class GetNumericService {
  public getNumberOrZero(value: string): number {
    return isNaN(+value) ? 0 : +value;
  }
}
